import { render, staticRenderFns } from "./OrganismTechnicalSpecs.vue?vue&type=template&id=783de754&scoped=true&"
import script from "./OrganismTechnicalSpecs.vue?vue&type=script&lang=js&"
export * from "./OrganismTechnicalSpecs.vue?vue&type=script&lang=js&"
import style0 from "./OrganismTechnicalSpecs.vue?vue&type=style&index=0&id=783de754&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783de754",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomBulletSpecs: require('/app/components/atoms/common/AtomBulletSpecs.vue').default,AtomsCommonAtomSpecsInfo: require('/app/components/atoms/common/AtomSpecsInfo.vue').default,AtomsProjectAtomCategorySpecs: require('/app/components/atoms/project/AtomCategorySpecs.vue').default})
